import CryptoJS from "crypto-js";
import { Buffer } from "buffer";

export function TokenDecrypt(token) {
  const encryptedData = token && token.data !== undefined ? token.data : token;

  if (!encryptedData) {
    return null;
  }
  try {
    const decryptedData = CryptoJS.AES.decrypt(
      encryptedData,
      "dBpb7TBo0RKGMleLvdx84hiXwntiIbep"
    ).toString(CryptoJS.enc.Utf8);
    const decodedData = Buffer.from(decryptedData, "base64").toString("utf-8");
    return JSON.parse(decodedData);
  } catch (err) {
    return null;
  }
}
